import axios, { AxiosResponse, AxiosResponseHeaders } from "axios";
import { LieferscheinData, LieferscheinDataFromDB } from "./liste/lieferscheinData";
import { RechnungData, RechnungDataFromDB } from "./listeRechnung/rechnungData";
import { KundeData } from "./kunden/kundeData";
import { Buchung, MeInfo, ZeitStatus, ZeitStoreData } from "./zeit/zeitData";


export class DataHandler {

    private static SERVER: string = "https://ls.hydromediahouse.at/api";
    private static DEV_SERVER: string = "http://localhost:8080/api";

    /** Kein Fehler des Backends, sondern eine abgelaufene Session. */
    public static SESSION_EXPIRED: string = "Sitzung abgelaufen. Bitte neu anmelden.";


    public static getServer(): string {
        console.log(process.env.REACT_APP_SERVER);

        if (window.location.host.indexOf('localhost:8080') !== -1)
            return this.DEV_SERVER;

        if (process.env.REACT_APP_SERVER)
            return process.env.REACT_APP_SERVER;
        return this.SERVER;
    }

    private static getLogoutUrl(): string {
        console.log(process.env.REACT_APP_LOGOUTURL);

        if (process.env.REACT_APP_LOGOUTURL)
            return process.env.REACT_APP_LOGOUTURL;
        return this.SERVER;
    }

    static sendRechnung(data: FormData, callback: (data: any) => void, errorCallback: (error: any) => void) {
        const value = Object.fromEntries(data.entries());
        const result: { [k: string]: any } = {};
        const newFormData = new FormData();
        for (let k in value) {
            const v = value[k];
            if (v.valueOf() instanceof File) {
                if ((v as File).size > 0) {
                    newFormData.set(k, v);
                    result[k] = (v as File).name;
                }
            }
            else {
                result[k] = v;
            }
        }
        newFormData.set('json', JSON.stringify(result));
        axios.post(DataHandler.getServer() + '/storeRg', newFormData).then(callback).catch(errorCallback);
    }

    static sendKunde(data: FormData, callback: (data: any) => void, errorCallback: (error: any) => void) {
        debugger;
        const value = Object.fromEntries(data.entries());
        const result: { [k: string]: any } = {};
        const newFormData = new FormData();
        for (let k in value) {
            const v = value[k];
            result[k] = v;

        }
        newFormData.set('json', JSON.stringify(result));
        axios.post(DataHandler.getServer() + '/storeKunde', newFormData).then(callback).catch(errorCallback);
    }

    static sendLieferschein(data: FormData, callback: (data: any) => void, errorCallback: (error: any) => void) {
        debugger;
        const value = Object.fromEntries(data.entries());
        const result: { [k: string]: any } = {};
        const newFormData = new FormData();
        for (let k in value) {
            const v = value[k];
            if (v.valueOf() instanceof File && (v as File).size > 0) {
                newFormData.set(k, v);
            }
            else {
                result[k] = v;
            }
        }
        newFormData.set('json', JSON.stringify(result));
        axios.post(DataHandler.getServer() + '/storeLs', newFormData).then(callback).catch(errorCallback);
    }


    static getLieferscheinList(showAll: boolean): Promise<Array<LieferscheinData>> {
        return new Promise<Array<LieferscheinData>>((resolve, reject) => {
            axios.get(DataHandler.getServer() + '/getLsList?allStates=' + showAll).then((data) => {
                const resultArray = DataHandler.createArrayFromData(data);
                resolve(resultArray);
            }).catch((error) => {
                debugger;
                reject(error);
            });
        });
    }

    static getKundenListe(): Promise<Array<KundeData>> {
        return new Promise<Array<KundeData>>((resolve, reject) => {
            axios.get(DataHandler.getServer() + '/getKundenList').then((data) => {
                debugger;
                const resultArray = data.data as Array<KundeData>;
                resolve(resultArray);
            }).catch((error) => {
                debugger;
                reject(error);
            });
        });
    }

    static getRechnungList(showAll: boolean): Promise<Array<RechnungData>> {
        return new Promise<Array<RechnungData>>((resolve, reject) => {
            axios.get(DataHandler.getServer() + '/getRgList?allStates=' + showAll).then((data) => {
                const resultArray = DataHandler.createArrayFromData(data);
                resolve(resultArray);
            }).catch((error) => {
                debugger;
                reject(error);
            });
        });
    }

    static doLogout(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            axios.get(DataHandler.getLogoutUrl()).then(() => {
                resolve();
            }).catch((error) => {
                debugger;
                reject(error);
            });
        });
    }

    static createPdf(id: number) {
        axios.post(DataHandler.getServer() + '/pdf',
            { id: id }, { responseType: 'blob' }).then((data) => {
                // create file link in browser's memory
                const href = URL.createObjectURL(data.data);
                let filename = 'lieferschein.pdf';
                if (data.headers !== undefined) {
                    const h = (data.headers)
                    const v = (h as AxiosResponseHeaders)
                    const y = v.get('filename') as string;
                    if (y)
                        filename = y;
                }

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            });
    }

    static createKundenCsv() {
        axios.get(DataHandler.getServer() + '/kundenCsv', { responseType: 'blob' }).then((data) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(data.data);
            let filename = 'kunden.csv';
            if (data.headers !== undefined) {
                const h = (data.headers)
                const v = (h as AxiosResponseHeaders)
                const y = v.get('filename') as string;
                if (y)
                    filename = y;
            }

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        });
    }

    static downloadImage(rechungsId: number, bildid: number) {
        axios.post(DataHandler.getServer() + '/rgImage',
            { rgid: rechungsId, bildid: bildid }, { responseType: 'blob' }).then((data) => {
                // create file link in browser's memory
                const href = URL.createObjectURL(data.data);
                let filename = 'bild.jpg';
                if (data.headers !== undefined) {
                    const h = (data.headers)
                    const v = (h as AxiosResponseHeaders)
                    const y = v.get('filename') as string;
                    if (y)
                        filename = y;
                }

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            });
    }

    static createRgPDF() {
        axios.post(DataHandler.getServer() + '/rgPDF',
            {}, { responseType: 'blob' }).then((data) => {
                // create file link in browser's memory
                const href = URL.createObjectURL(data.data);
                let filename = 'rechnungen.pdf';
                if (data.headers !== undefined) {
                    const h = (data.headers)
                    const v = (h as AxiosResponseHeaders)
                    const y = v.get('filename') as string;
                    if (y)
                        filename = y;
                }

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            });
    }

    static deleteKunde(id: number): Promise<Array<KundeData>> {
        return new Promise<Array<KundeData>>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/deleteKunde', { id: id }).then((data) => {
                const resultArray = data.data as Array<KundeData>
                resolve(resultArray);
            }).catch((error) => {
                reject(error);
            });
        });
    }


    static setLieferscheinDone(id: number): Promise<Array<LieferscheinData>> {
        return new Promise<Array<LieferscheinData>>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/setDone', { id: id }).then((data) => {
                const resultArray = DataHandler.createArrayFromData(data);
                resolve(resultArray);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static setAllActiveRgInactive(): Promise<Array<RechnungData>> {
        return new Promise<Array<RechnungData>>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/deactivateAllRg').then((data) => {
                const resultArray = DataHandler.createArrayFromData(data);
                resolve(resultArray);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static setRechungDone(id: number): Promise<Array<RechnungData>> {
        return new Promise<Array<RechnungData>>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/setDoneRg', { id: id }).then((data) => {
                const resultArray = DataHandler.createArrayFromData(data);
                resolve(resultArray);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static getLieferschein(id: number): Promise<LieferscheinDataFromDB> {
        return new Promise<LieferscheinDataFromDB>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/getLs', { id: id }).then((data) => {
                if (data.data) {
                    resolve(data.data);
                }
                else
                    reject("Could not resolve data");
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static getKunde(id: number): Promise<KundeData> {
        return new Promise<KundeData>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/getKunde', { id: id }).then((data) => {
                if (data.data) {
                    resolve(data.data);
                }
                else
                    reject("Could not resolve data");
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static getRechnung(id: number): Promise<RechnungDataFromDB> {
        return new Promise<RechnungDataFromDB>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/getRg', { id: id }).then((data) => {
                if (data.data) {
                    resolve(data.data);
                }
                else
                    reject("Could not resolve data");
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static checkSessionExpired() {
        return new Promise<void>((resolve, reject) => {
            axios.get(DataHandler.getServer() + '/loggedIn', {
                maxRedirects: 0,
                validateStatus(status) {
                    debugger;
                    return status === 204;
                },
            }).catch((error) => {
                reject(error);
            }).then(() => {
                resolve();
            });
        });
    }


    // --- Zeiterfassung, siehe docs/zeiterfassung-api.md ---

    /** Angemeldeter Benutzer und seine Berechtigungen, steuert die Editor-UI. */
    static getMe(): Promise<MeInfo> {
        return DataHandler.zeitRequest<MeInfo>(
            axios.get(DataHandler.getServer() + '/me'), 'Benutzer konnte nicht ermittelt werden.');
    }

    static getZeitStatus(): Promise<ZeitStatus> {
        return DataHandler.zeitRequest<ZeitStatus>(
            axios.get(DataHandler.getServer() + '/zeit/status'), 'Status konnte nicht geladen werden.');
    }

    static zeitKommen(): Promise<ZeitStatus> {
        return DataHandler.zeitRequest<ZeitStatus>(
            axios.post(DataHandler.getServer() + '/zeit/kommen'), 'Kommen konnte nicht gebucht werden.');
    }

    static zeitGehen(): Promise<ZeitStatus> {
        return DataHandler.zeitRequest<ZeitStatus>(
            axios.post(DataHandler.getServer() + '/zeit/gehen'), 'Gehen konnte nicht gebucht werden.');
    }

    static getZeitList(von: string, bis: string, user?: string): Promise<Array<Buchung>> {
        return DataHandler.zeitRequest<Array<Buchung>>(
            axios.post(DataHandler.getServer() + '/zeit/list', { von: von, bis: bis, user: user ? user : '' }),
            'Zeiten konnten nicht geladen werden.');
    }

    /** Legt an oder ändert. Mit von/bis liefert das Backend die aktualisierte Liste. */
    static storeZeit(data: ZeitStoreData): Promise<Array<Buchung>> {
        return DataHandler.zeitRequest<Array<Buchung>>(
            axios.post(DataHandler.getServer() + '/zeit/store', data), 'Buchung konnte nicht gespeichert werden.');
    }

    static deleteZeit(id: number, von: string, bis: string): Promise<Array<Buchung>> {
        return DataHandler.zeitRequest<Array<Buchung>>(
            axios.post(DataHandler.getServer() + '/zeit/delete', { id: id, von: von, bis: bis }),
            'Buchung konnte nicht gelöscht werden.');
    }

    static createZeitPdf(von: string, bis: string, user?: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            axios.post(DataHandler.getServer() + '/zeit/pdf',
                { von: von, bis: bis, user: user ? user : '' }, { responseType: 'blob' }).then((data) => {
                    // Ohne Session kommt die Login-Seite zurueck, die soll niemand als PDF speichern.
                    if (data.data instanceof Blob && data.data.type.indexOf('html') !== -1) {
                        reject(DataHandler.SESSION_EXPIRED);
                        return;
                    }
                    DataHandler.downloadResponse(data, 'zeiten.pdf');
                    resolve();
                }).catch((error) => {
                    DataHandler.fehlerText(error, 'Zeitenübersicht konnte nicht erstellt werden.').then(reject);
                });
        });
    }

    private static zeitRequest<T>(request: Promise<AxiosResponse<any, any>>, fallback: string): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            request.then((data) => {
                // Ohne Session leitet Jetty auf /login um, axios folgt der Umleitung
                // und liefert HTML statt JSON - das ist keine Antwort, sondern ein Logout.
                if (typeof data.data === 'string')
                    reject(DataHandler.SESSION_EXPIRED);
                else
                    resolve(data.data as T);
            }).catch((error) => {
                DataHandler.fehlerText(error, fallback).then(reject);
            });
        });
    }

    /**
     * Klartext aus der Antwort, den das Backend bei 400/403/409/500 mitschickt.
     * Beim PDF steckt er in einem Blob, weil responseType 'blob' gesetzt ist.
     */
    private static fehlerText(error: any, fallback: string): Promise<string> {
        const data = error && error.response ? error.response.data : undefined;
        if (data instanceof Blob)
            return data.text().then((text) => text.trim().length > 0 ? text : fallback).catch(() => fallback);
        if (typeof data === 'string' && data.trim().length > 0)
            return Promise.resolve(data);
        if (error && error.message)
            return Promise.resolve(error.message as string);
        return Promise.resolve(fallback);
    }

    /** Antwort als Datei speichern, Dateiname kommt aus dem Header 'filename'. */
    private static downloadResponse(data: AxiosResponse<any, any>, fallbackName: string) {
        const href = URL.createObjectURL(data.data);
        let filename = fallbackName;
        if (data.headers !== undefined) {
            const v = (data.headers as AxiosResponseHeaders);
            const y = v.get('filename') as string;
            if (y)
                filename = y;
        }

        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }


    private static createArrayFromData(data: AxiosResponse<any, any>): Array<LieferscheinData> {
        const resultArray: Array<LieferscheinData> = [];
        if (data.data) {
            for (let d of data.data) {
                const ld: LieferscheinData = {
                    id: d.id,
                    images: [],
                    state: d.state,
                    json: d.jsonForDB,
                    timestamp: d.timestamp,
                    user: d.user
                }
                resultArray.push(ld);
            }
        }
        return (resultArray);
    }


}


